import styled from 'styled-components';

/**
 * Maison-style wide column (~95vw, soft cap). Use for homepage product rails + headings so cards
 * share the same effective width rhythm as maison/client `Container`.
 */
export const ProductCatalogWide = styled.div`
  box-sizing: border-box;
  width: ${({ theme }) => theme.layout.catalogWidth};
  max-width: ${({ theme }) => theme.layout.catalogMaxWidth};
  margin-left: auto;
  margin-right: auto;
  padding-left: ${({ theme }) => theme.layout.containerPadX};
  padding-right: ${({ theme }) => theme.layout.containerPadX};
`;

/**
 * Product card strip + grid aligned with maison/client ProductCardLayout:
 * mobile: ~2 tiles per view in horizontal scroll; md+: tighter columns; lg+: grid; xl: 6 columns.
 */

export const ProductCardsScrollOuter = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  margin-left: calc(0px - ${({ theme }) => theme.layout.containerPadX});
  margin-right: calc(0px - ${({ theme }) => theme.layout.containerPadX});
  padding-left: ${({ theme }) => theme.layout.containerPadX};
  padding-right: ${({ theme }) => theme.layout.containerPadX};
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    overflow: visible;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const ProductCardsStrip = styled.div`
  display: flex;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 24px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
`;

export const ProductCardShell = styled.div`
  flex: 0 0 calc(50% - 8px);
  min-width: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex: 0 0 calc(25% - 18px);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex: none;
    min-width: 0;
  }
`;

export const ProductCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 24px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 24px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
`;
